import React, { useState } from 'react'
import { Box } from '@mui/material'
import '../../../styles/pages.css'
import CreateEnvironment from '../shared/CreateEnvironmentForm'
import { ISchoolCreate } from 'infrastructure/api'
import { useNavigateTo } from 'infrastructure/routing'
import { useWithErrorNotification } from 'shared/ui/GlobalDialog'
import { makeKiddomPostRequest } from 'infrastructure/api'

export default function SchoolCreate() {
  return <SchoolCreateWithDistrict />
}

export function SchoolCreateWithDistrict({
  districtID,
}: {
  districtID?: number
}) {
  const doCreateSchool = useWithErrorNotification(
    { errorTitle: 'Error creating school, please try again.' },
    (requestBody: object) => {
      return makeKiddomPostRequest<{ id: number }>({
        kiddomPath: `/api/schools`,
        requestBody,
      })
    },
  )
  const [schoolName, setSchoolName] = useState('')
  const [isVerified, setIsVerified] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigateTo()

  const onSubmit = async () => {
    const body: ISchoolCreate = {
      name: schoolName,
      is_verified: isVerified,
      city: '-',
      state: '-',
      country: '-',
    }
    if (districtID) {
      body.district_id = districtID
    }

    try {
      const res = await doCreateSchool(body)
      if (!res) return
      navigate(`/schools/${res.id}/show`)
    } catch (e: any) {
      setError('Error creating school, please try again.')
    }
  }
  return (
    <Box>
      <CreateEnvironment
        label="School Name"
        updateName={setSchoolName}
        updateVerified={setIsVerified}
        onSubmit={onSubmit}
      />
      <Box m={2}>{error && <p className="error">{error}</p>} </Box>
    </Box>
  )
}
